<template>
	<div id="app" :class="(((typeof weather.main) != 'undefined') && (weather.main.temp > 16))? 'warm' : '' ">
		<main>
            <h2 class="title">Towns Search</h2>
            <hr style="margin-bottom: 20px;">
			<div class="search-box">
				<input
					type="text"
					class="search-bar"
					v-model="query"
					placeholder="Search a town or a country 'Paris'  'France, FR' "
					@keypress="fetchWeather"
				/>
			</div>

			<div class="weather-wrap" v-if="typeof weather.main != 'undefined'">
				<div class="location-box">
					<div class="location">{{ weather.name }}, {{ weather.sys.country }}</div>
					<div class="date">{{ dateBuilder() }}</div>
				</div>
				<div class="weather-box">
					<div class="temperature">{{ Math.round(weather.main.temp) }}°c</div>
					<div class="weather">{{ weather.translate }}</div>
				</div>
			</div>

            <div>
                <hr style="width: 30%;margin-bottom: 20px;min-width: 290px;">
                
                
                <details>
                    <summary><h2 class="title">System Towns</h2></summary>
                                    <div class="system-towns-container">
                    <div class="system-town-box" v-for="town in displaySystemTowns" :key="town.name" >
                        <div class="location">{{ town.name }}</div>
                        <div class="temperature" v-if="town.weather">
                            {{ Math.round(town.weather.main.temp) }}°c
                        </div>
                        <div class="weather" v-if="town.weather">
                            {{ town.translate }}
                        </div>
                    </div>
                </div>
                </details>
                

            </div>
		</main>
	</div>
</template>

<script>
	let weatherTranslate = {};
	weatherTranslate["fog"] = "Brouillard";
	weatherTranslate["Thunderstorm"] = "Orageux";
	weatherTranslate["Mist"] = "Brumeux";
	weatherTranslate["Drizzle"] = "Bruine";
	weatherTranslate["Rain"] = "Pluvieux";
	weatherTranslate["Snow"] = "Neigeux";
	weatherTranslate["Smoke"] = "Brouillard de Fumée";
	weatherTranslate["Haze"] = "Brume";
	weatherTranslate["Dust"] = "Poussiéreux";
	weatherTranslate["Sand"] = "sablonneux";
	weatherTranslate["Ash"] = "Cendreux";
	weatherTranslate["Squall"] = "Bourrasque";
	weatherTranslate["Tornado"] = "Tornade";
	weatherTranslate["Clear"] = "Dégager";
	weatherTranslate["Clouds"] = "Nuageux";

export default {
    name: 'App',
    data() {
        return {
            api_key: 'd47a4adf9121f10b52f9d5f8adbfbee8',
            url_base: "https://api.openweathermap.org/data/2.5/",
            query: '',
            weather: {},
            systemTowns: ["Chelles", "Villepinte","Drancy","Saint-Mesmes","Dreux","Champigny","Paris","Lyon","Marly-La-Ville"],
            displaySystemTowns: []
        };
    },
    created() {
        this.fillSystemTowns();
    },
    methods: {
        async fetchWeatherForTown(townName) {
            try {
                const response = await fetch(
                    `${this.url_base}weather?q=${townName}&units=metric&APPID=${this.api_key}`
                );
                const data = await response.json();
                if (data.cod === 200) {
                    data.translate = weatherTranslate[data.weather[0].main];
                    return data;
                } else {
                    console.error(`Erreur pour ${townName}:`, data.message);
                    return null;
                }
            } catch (error) {
                console.error(`Erreur lors de la récupération des données pour ${townName}:`, error);
                return null;
            }
        },
        async fillSystemTowns() {
            this.displaySystemTowns = await Promise.all(
                this.systemTowns.map(async (town) => {
                    const weatherData = await this.fetchWeatherForTown(town);
                    return {
                        name: town,
                        weather: weatherData,
                        translate: weatherData ? weatherData.translate : null
                    };
                })
            );
        },
        fetchWeather(e) {
            if (e.key === "Enter") {
                fetch(`${this.url_base}weather?q=${this.query}&units=metric&APPID=${this.api_key}`)
                    .then(response => {
                        console.log(response);
                        return response.json();
                    })
                    .then(this.setResult);
            } else {
                console.log("IN fetchWeather");
            }
        },
        setResult(results) {
            this.weather = results;
            this.weather.translate = weatherTranslate[this.weather.weather[0].main];
            console.log(this.weather.translate);
            console.log(this.weather.weather[0].main);
        },
        dateBuilder() {
            let d = new Date();
            let months = [
                'Janvier', 'Fevrier', 'Mars', 'Avril',
                'Mai', 'Juin', 'Juillet', 'Août',
                'Septembre', 'Octobre', 'Novembre', 'Décembre'
            ];
            let days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];

            let day = days[d.getDay()];
            let date = d.getDate();
            let month = months[d.getMonth()];
            let year = d.getFullYear();

            return `${day} ${date} ${month} ${year}`;
        }
    }
};
</script>

<style>
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

body {
	font-family: 'Agency FB';
}

#app {
	background-image: url('./assets/cold-bg.jpg');
	background-size: cover;
	background-position: bottom;
	transition: 0.4s;
}

#app.warm {
	background-image: url('./assets/warm-bg.jpg');
}

main {
	min-height: 100vh;
	padding: 25px;
	background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.75));
}

.search-box {
	width: 100%;
	margin-bottom: 30px;
}

.search-box .search-bar {
	font-family: 'Agency FB';
	display: block;
	width: 100%;
	padding: 15px;
	color: #313131;
	font-size: 20px;
	appearance: none;
	border: none;
	outline: none;
	background: none;
	box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
	background-color: rgba(255, 255, 255, 0.20);
	border-radius: 0px 16px 0px 16px;
	transition: 0.4s;
}

.search-box .search-bar:focus {
	box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
	background-color: rgba(255, 255, 255, 0.75);
	border-radius: 16px 0px 16px 0px;
}

.location-box .location {
	color: #FFF;
	font-size: 40px;
	font-weight: 500;
	text-align: center;
	text-shadow: 1px 3px rgba(0, 0, 0, 0.25);
}

.location-box .date {
	color: #FFF;
	font-size: 32px;
	font-style: italic;
	text-align: center;
}
.title{
    color: rgb(179, 179, 179);
}
.weather-box {
	text-align: center;
}
details > summary {
    list-style: none;
}
.weather-box .temperature {
	display: inline-block;
	padding: 10px 25px;
	color: #FFF;
	font-size: 102px;
	font-weight: 900;
	text-shadow: 3px 6px rgba(0, 0, 0, 0.25);
	background-color: rgba(255, 255, 255, 0.25);
	border-radius: 16px;
	margin: 30px 0px;
	box-shadow: 3px 6px rgba(0, 0, 0, 0.25);
}

.weather-box .weather {
	color: #FFF;
	font-size: 48px;
	font-style: italic;
	text-shadow: 3px 6px rgba(0, 0, 0, 0.25);
}

.system-towns-container {
    justify-content: center;
}

.system-town-box {
    display: flex;
    min-width: 290px;
    width: 30%;
    
    justify-content: space-around;
    margin-bottom: 20px;
    background-color: rgba(255, 255, 255, 0.25);
    box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
    border-radius: 16px 0px 16px 0px;
    color: #FFF;
}

.system-town-box .location {
    font-size: 30px;
    margin-bottom: 10px;
    text-shadow: 1px 3px rgba(0, 0, 0, 0.25);
}

.system-town-box .temperature {
    font-size: 30px;
    text-shadow: 3px 6px rgba(0, 0, 0, 0.25);
}

.system-town-box .weather {
    font-size: 30px;
    font-style: italic;
    text-shadow: 3px 6px rgba(0, 0, 0, 0.25);
}
</style>